import { COMMERCIAL_BILLING_NAV_KEYS } from '@/components/SiderMenu/utils/sessionNavigation';

/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'channelAgreements';

/**
 * Descriptor route token (import/export/tasks disabled).
 * Runtime list/detail/CRUD base path comes from session navigation (commercial billing).
 */
export const FETCH_ROUTE = 'channel-agreements';

/** Singular entity name for shared helpers / notifications. */
export const ENTITY_NAME = 'channelAgreement';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'channelAgreements';

/** Default OData sort when the user clears column sorting. */
export const DEFAULT_ORDER_BY = 'name asc';

/** Session navigation key used to resolve the commercial billing API base path. */
export const NAVIGATION_KEY = COMMERCIAL_BILLING_NAV_KEYS.COMMERCIAL_AGREEMENTS;
